import Vue from 'vue';
import VueRouter from 'vue-router';
import imApi from "@/utils/imapi";
import { setLocalStorage } from "@/utils/local-storage";
import axios from '@/api/request';
Vue.use(VueRouter)

const routes = [{
  path: '/login',
  name: 'login',
  component: function () {
    return import('@/views/login/index.vue')
  },
  meta: { title: '登录' }
},
{
  path: '/',
  name: 'home',
  component: function () {
    return import('@/views/home/index.vue')
  },
},
{
  path: '/setting',
  name: 'setting',
  component: function () {
    return import('@/views/setting/index.vue')
  },
  children: [
    { //客户管理 客户列表
      path: "/customermanagement",
      component: () => import("@/views/setting/CustomerManagement/index.vue"),
      children: [
        {
          path: "customerlist",
          component: () => import("@/views/setting/CustomerManagement/CustomerList/index.vue"),
          name: "customerlist",
          meta: { title: '访客列表' }
        },
        {
          path: "blacklist",
          component: () => import("@/views/setting/CustomerManagement/BlackList/index.vue"),
          name: "blacklist",
          meta: { title: '黑名单' }
        },
        {
          path: "conversationrecord",
          component: () => import("@/views/setting/CustomerManagement/ConversationRecord/index.vue"),
          name: "conversationrecord",
          meta: { title: '会话记录' }
        },
        {
          path: "formlist",
          component: () => import("@/views/setting/CustomerManagement/FormList/index.vue"),
          name: "formlist",
          meta: { title: '表单列表' }
        },
      ]
    },
    { //基础设置
      path: "/basesettings",
      component: function () {
        return import('@/views/setting/BaseSettings/index.vue')
      },
      children: [
        {
          path: "questioning",
          component: () => import("@/views/setting/BaseSettings/Questioning/index.vue"),
          name: "Questioning",
          meta: { title: '发问引导' }
        },
        {
          path: "profile",
          component: () => import("@/views/setting/BaseSettings/Profile/index.vue"),
          name: "Profile",
          meta: { title: '个人资料' }
        },
        {
          path: "activemarketing",
          component: () => import("@/views/setting/BaseSettings/ActiveMarketing/index.vue"),
          name: "ActiveMarketing",
          meta: { title: '主动营销' }
        },
        {
          path: "sessionSetting",
          component: () => import("@/views/setting/component/sessionSetting.vue"),
          name: "sessionSetting",
          meta: { title: '会话分配' }
        },
        {
          path: "notifySetting",
          component: () => import("@/views/setting/component/notifySetting.vue"),
          name: "notifySetting",
          meta: { title: '通知设置' }
        },
        { //留言表单
          path: "leaveMesForm",
          component: () => import("@/views/setting/BaseSettings/LeaveMesForm/index.vue"),
          name: "leaveMesForm",
          meta: { title: '留言表单' }
        },
        { // 话术库
          path: "Library",
          component: () => import("@/views/setting/BaseSettings/Library/index.vue"),
          name: "Library",
          meta: { title: '话术库' }
        },
        {
          path: "blockwords",
          component: () => import("@/views/setting/CommonSettings/BlockWords/index.vue"),
          name: "BlockWords",
          meta: { title: '屏蔽词' }
        },
        //更新日志
        {
          path: "updatelog",
          component: () => import("@/views/setting/BaseSettings/UpdateLogs/index.vue"),
          name: "UpdateLog",
          meta: { title: '更新日志' }
        },
      ]
    },
    { //公共设置
      path: "/commonsettings",
      component: function () {
        return import('@/views/setting/CommonSettings/index.vue')
      },
      children: [
        {
          path: "accountinfo",
          component: () => import("@/views/setting/CommonSettings/AccountInfo/index.vue"),
          name: "AccountInfo",
          meta: { title: '账号信息' }
        },
        {
          path: "kefulist",
          component: () => import("@/views/setting/CommonSettings/KefuList/index.vue"),
          name: "KefuList",
          meta: { title: '客户列表' }
        },
        {
          path: "sitelist",
          component: () => import("@/views/setting/CommonSettings/SiteList/index.vue"),
          name: "SiteList",
          meta: { title: '站点列表' }
        },
        {
          path: "sitedetails",
          component: () => import("@/views/setting/CommonSettings/SiteList/siteDetails.vue"),
          name: "SiteDetails",
          meta: { title: '站点详情' }
        },
        {
          path: "documentlist",
          component: () => import("@/views/setting/CommonSettings/DocumentList/index.vue"),
          name: "DocumentList",
          meta: { title: '文档列表' }
        },
        {
          path: "documentdetails",
          component: () => import("@/views/setting/CommonSettings/DocumentList/documentDetails.vue"),
          name: "DocumentDetails",
          meta: { title: '文档详情' }
        },
        {
          path: "aistudy",
          component: () => import("@/views/setting/CommonSettings/AIStudy/index.vue"),
          name: "AIStudy",
          meta: { title: 'AI学习' }
        },
      ]
    },
    {
      //ai 资料库
      path: "aidata",
      component: () => import("@/views/setting/AIData/index.vue"),
      name: "aidata",
      meta: { title: 'AI 资料库' }
    }
  ]
}
]

const router = new VueRouter({
  // mode: 'history',
  // base: process.env.BASE_URL,
  routes
})

router.beforeEach((to, from, next) => {
  // console.log(to.path);
  // 设置网站 title 名称
  const auth = localStorage.getItem('auth');
  let RoleName = "";
  if (auth == 'user') {
    RoleName = "客户后台";
  } else if (auth == "cs") {
    RoleName = "客服后台";
  }
  if (to.meta.title) {
    document.title = `${to.meta.title} - IM 客服系统 ${RoleName}`;
  }

  if (to.path === '/login') {
    next()
  } else {
    // 如果 URL 中包含 kct
    if (to.query.kct) {
      // localStorage.setItem('Authorization', to.query.kct);
      const kct = to.query.kct;
      axios.get(`${Vue.prototype.$baseURL}api/IMAPI/getLoginInfo?kct=${kct}`)
        .then(response => {
          // 处理成功响应
          if (response.data.code == 200) {
            setLocalStorage({
              Authorization: response.data.data.access_token || '',
              Expire: response.data.data.profile.expires_at || '',
              auth: response.data.data.profile.auth || '',
              curRoom: '',
            });
            // localStorage.setItem('Authorization', response.data.data.access_token);
            const imAPI = new imApi();
            imAPI.GetUserInfo(response.data.data.profile.sid).then(data1 => {
              // 构造并保存用户信息
              var info = {
                UserInfo: JSON.stringify(data1.userinfo),
                SiteIds: data1.serviceIds
              };
              setLocalStorage(info);

              // 如果是通过 kct 进入后台的话，默认点击第一条数据触发事件，通过事件总线 EventBus 进入首页的 index.vue
              const roomsInfo = JSON.parse(localStorage.getItem(`RoomsInfo_${JSON.parse(info.UserInfo).id}`))
              if (roomsInfo && roomsInfo.length > 0) {
                //EventBus.$emit('select-room', { room: roomsInfo[0], type: 1 });
                //记录第一个房间信息
                setLocalStorage({ curRoom: JSON.stringify(roomsInfo[0]) });
              }
              else {
                setLocalStorage({ curRoom: '' });
              }
              const url = location.hash.replace(/^#/ig, '').split('?')[0]
              next({
                path: url
              })

            }).catch(err => {
              // 获取用户信息失败时的错误处理
              console.log(err);
            });
          } else if (response.data.code == 1001) {
            // 跳转到错误页面 1001
            next('/login');
          } else {
            // 其他错误
            next('/login');
          }
        })
        .catch(error => {
          // 处理请求错误
          console.error(error);
          next('/login');
        });

    } else {
      const token = localStorage.getItem('Authorization');
      if (token) {
        next()
      } else {
        next('/login')
      }
    }

  }

})

export default router;